import React from 'react';
import { Modal, Button, Result, Typography } from 'antd';
import { CheckCircle, ArrowRight, Plus } from 'lucide-react';

const { Text, Title } = Typography;

const StrategySavedModal = ({ 
  open, 
  onClose, 
  strategyName, 
  isEditMode, 
  onCreateNew, 
  onNavigateToSignals,
  isTimeBased
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={480}
      className="strategy-saved-modal"
      bodyStyle={{ padding: '20px' }}
    >
      <div style={{ textAlign: 'center' }}>
        <div className='check-circle'>
          <CheckCircle size={36} color="#52c41a" strokeWidth={2.5} />
        </div>
        
        <Title level={4} style={{ margin: '0 0 12px 0', fontSize: '20px' }}>
        {strategyName} saved!
        </Title>

          <>
            <p style={{ marginBottom: '24px'}}>
              {isTimeBased 
                ? "Your time based strategy has been created. The strategy will execute when time conditions are met."
                : "Next configure a Signal and link it to a broker account."
              }
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {!isTimeBased && (
                <Button
                  type="primary"
                  size="large"
                  className='btn-apply'
                  icon={<ArrowRight size={18} />}
                  onClick={onNavigateToSignals}
                >
                  Take me to Signal Config
                </Button>
              )}
              <Button
                size="large"
                className='btn-reset'
                icon={<Plus size={18} />}
                onClick={onCreateNew}
              >
                Create New Strategy
              </Button>
            </div>
          </>
      </div>
    </Modal>
  );
};

export default StrategySavedModal;
